
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchOutTaxGrid extends Serenity.EntityGrid<BranchOutTaxRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchOutTax'; }
        protected getDialogType() { return BranchOutTaxDialog; }
        protected getIdProperty() { return BranchOutTaxRow.idProperty; }
        protected getInsertPermission() { return BranchOutTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchOutTaxRow.localTextPrefix; }
        protected getService() { return BranchOutTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}